import React, { useEffect, useState } from "react";
import { ExternalLink, Play, X } from "lucide-react";
import { getInstagramReels } from "./api";
import "./reels.css";

const displayDate = (value) =>
  value
    ? new Intl.DateTimeFormat("tr-TR", { dateStyle: "medium" }).format(
        new Date(value),
      )
    : "";

export function ReelsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [active, setActive] = useState(null);
  useEffect(() => {
    let alive = true;
    getInstagramReels()
      .then((next) => alive && setData(next))
      .catch((reason) => alive && setError(reason.message));
    return () => {
      alive = false;
    };
  }, []);
  return (
    <main>
      <section className="page-title reels-title">
        <div className="shell">
          <p className="eyebrow">@AYDIN_BARAN_EMLAK</p>
          <h1>Reels</h1>
          <p>Portföylerimizi ve güncel videolarımızı keşfedin.</p>
        </div>
      </section>
      <section className="shell section reels-page">
        {!data && !error ? (
          <p className="loading">Reels yükleniyor…</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : !data.configured ? (
          <div className="reels-empty">
            <h2>Reels akışı hazırlanıyor</h2>
            <p>
              Instagram hesabımız bağlandığında yeni videolar burada otomatik
              görünecek.
            </p>
          </div>
        ) : data.reels?.length ? (
          <div className="reels-grid">
            {data.reels.map((reel) => (
              <article className="reel-card" key={reel.id || reel.permalink}>
                <button
                  type="button"
                  onClick={() => setActive(reel)}
                  aria-label="Reels videosunu izle"
                >
                  {reel.thumbnail_url ? (
                    <img
                      src={reel.thumbnail_url}
                      loading="lazy"
                      decoding="async"
                      alt="Instagram Reels önizlemesi"
                    />
                  ) : (
                    <div className="reel-placeholder" />
                  )}
                  <span className="reel-play">
                    <Play fill="currentColor" /> İzle
                  </span>
                </button>
                <div>
                  <p>{reel.caption || "Baran Emlak Reels"}</p>
                  <small>{displayDate(reel.timestamp)}</small>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="reels-empty">
            <h2>Henüz Reel bulunmuyor</h2>
            <p>Yeni videolar yayımlandığında burada görünecek.</p>
          </div>
        )}
        {active && (
          <div
            className="reel-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Instagram Reels videosu"
          >
            <button
              type="button"
              className="reel-modal-close"
              onClick={() => setActive(null)}
              aria-label="Videoyu kapat"
            >
              <X />
            </button>
            <iframe
              src={active.embed_url}
              title="Instagram Reels"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen"
              allowFullScreen
            />
            <a href={active.permalink} target="_blank" rel="noreferrer">
              Instagram’da aç <ExternalLink />
            </a>
          </div>
        )}
      </section>
    </main>
  );
}
